import { useEffect, useRef } from 'react'
import formatPhoneNumber from '../../../utils/formatPhoneNumber'
import getTextColor from '../../../utils/getTextColor'
import DesktopDialogWrapper from '../DesktopDialogWrapper'
import CloseIcon from './CloseIcon'
import styles from './Dialog.module.css'

const DesktopDialogIntro = ({ data, onClose, onReject, phoneNumber, setPhoneNumber, isPhoneNumberValid, phoneValidationMessage, onSubmit, withOverlay = true, isLoading, isSocketConnectionFailed }) => {
  const inputRef = useRef(null)

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus()
    }
  }, [])

  const brandColor = data?.brandColor
  const popupTitle = data?.popupTitle?.value
  const popupDescription = data?.popupDescription?.value
  const hotelName = data?.hotelName
  const messagingPolicyUrl = data?.messagingPolicyUrl

  const legalText = `By accepting below, you agree to receive recurring personalized promotional and marketing text messages from ${hotelName}. Reply HELP for help and STOP to cancel. Message frequency varies. Message and data rates may apply.`

  const popupButtonText = data?.popupButtonText?.value

  return (
    <DesktopDialogWrapper data={data} withOverlay={withOverlay}>
      {withOverlay && <button onClick={onClose} className={styles.closeButton}><CloseIcon fill="gray" /></button>}
      <p className={styles.desktopPopupTitle}>{popupTitle}</p>
      <p className={styles.desktopPopupDescription}>{popupDescription}</p>
      <p className={styles.desktopAdditionalDescription}>
        {legalText} View <a href={messagingPolicyUrl} target="_blank" rel="noreferrer">Privacy Policy</a>.
      </p>
      <input ref={inputRef} className={styles.desktopTelInput} type="tel" id='phone' name='phone' placeholder='Mobile number' value={phoneNumber} onChange={e => setPhoneNumber(formatPhoneNumber(e.target.value))} onKeyDown={e => e.key === 'Enter' && !isLoading && onSubmit()} disabled={isLoading} />
      {!isPhoneNumberValid && 
      <p className={styles.desktopPhoneValidationError}>{phoneValidationMessage || 'Please enter a valid mobile number'}</p>}
      {isSocketConnectionFailed && <p className={styles.desktopPhoneValidationError}>Failed to connect. Please try again later.</p>}
      <button onClick={onSubmit} className={styles.desktopCta} style={{ backgroundColor: brandColor }} disabled={isLoading}>
        <p className={styles.desktopCtaMainText} style={{color: getTextColor(brandColor)}}>{popupButtonText}</p>
        <p className={styles.desktopCtaSupplimentaryText} style={{color: getTextColor(brandColor)}}>When you sign up for texts</p>
      </button>
      <button onClick={onReject} className={styles.noThanksButton}>No thanks</button>
    </DesktopDialogWrapper>

  ) 
}

export default DesktopDialogIntro